// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../Assets/DeWatermark.ai_1754806856125.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Left Panel ─────────────── */
.left-panel {
  background: linear-gradient(135deg, #001F54, #007BFF, #32CD32);
  clip-path: ellipse(85% 100% at 10% 50%);
  padding: 20px;
  text-align: center;
  margin-top: -40px;
}

.left-panel-sub {
  max-width: 420px;
  margin: 0 auto;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* ── Right Panel ─────────────── */
.right-panel {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  position: relative;
}

.right-panel::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.95);
  z-index: 1;
}

.right-panel > * {
  position: relative;
  z-index: 2;
}

/* ── Login Card ──────────────── */
.login-card {
  width: 460px;
  border-radius: 12px;
  overflow: hidden;
}

/* ── Logo ────────────────────── */
.logo-wrapper {
  width: 280px;
  height: 68px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* ── Change username link ────── */
.change-link {
  font-size: 0.78rem;
  color: #0d6efd;
  cursor: pointer;
  text-decoration: underline;
  -webkit-user-select: none;
          user-select: none;
}

.change-link:hover {
  color: #0056b3;
}

/* ── Input focus ─────────────── */
input:focus {
  outline: none !important;
  box-shadow: none !important;
  border-color: inherit !important;
}

/* ══════════════════════════════════════════════════════════
   RECENT LOGINS SECTION
══════════════════════════════════════════════════════════ */
.recent-logins-section {
  border-top: 1px solid #dee2e6;
  margin-top: 16px;
  padding-top: 12px;
}

.recent-logins-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.recent-logins-title-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.recent-logins-icon {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 1.5px solid #001F54;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #fff;
}

.recent-logins-count-label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

.recent-logins-clear-btn {
  font-size: 11px;
  color: #dc3545;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-weight: 500;
  flex-shrink: 0;
}

.recent-logins-clear-btn:hover {
  text-decoration: underline;
}

.recent-logins-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.recent-login-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  background: #fff;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.recent-login-row:hover {
  background: #f0f4ff;
  border-color: #b0c4f0;
}

.recent-login-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.recent-login-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.recent-login-info {
  display: flex;
  flex-direction: column;
}

.recent-login-username {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
}

.recent-login-badge {
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 20px;
  font-weight: 500;
  align-self: flex-start;
  margin-top: 2px;
}

.recent-login-remove {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #f8d7da;
  color: #842029;
  border: none;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
  padding: 0;
  transition: background 0.15s;
}

.recent-login-remove:hover {
  background: #f5c2c7;
}

/* ── Footer ──────────────────── */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(135deg, #007BFF, #32CD32);
  padding: 0.6rem 0;
  display: flex;
  align-items: center;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.footer .fw-bold {
  font-size: 1rem;
  letter-spacing: 0.5px;
}

/* ══════════════════════════════════════════════════════════
   IMPROVED ERROR POPUP
══════════════════════════════════════════════════════════ */

/* Overlay — clicking outside closes the popup */
.popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
  animation: overlayFadeIn 0.2s ease;
}

@keyframes overlayFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

/* Popup box */
.popup-box {
  background: #fff;
  padding: 28px 24px 22px;
  border-radius: 14px;
  max-width: 360px;
  width: 92%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
  animation: popupSlideUp 0.22s ease;
  text-align: center;
}

@keyframes popupSlideUp {
  from { opacity: 0; transform: translateY(18px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0)    scale(1);    }
}

/* Shake animation for wrong input */
@keyframes popupShake {
  0%   { transform: translateX(0);    }
  12%  { transform: translateX(-8px); }
  25%  { transform: translateX(7px);  }
  37%  { transform: translateX(-6px); }
  50%  { transform: translateX(5px);  }
  62%  { transform: translateX(-4px); }
  75%  { transform: translateX(3px);  }
  87%  { transform: translateX(-2px); }
  100% { transform: translateX(0);    }
}

.popup-shake {
  animation: popupShake 0.6s cubic-bezier(.36,.07,.19,.97) both;
}

/* Warning icon circle */
.popup-icon-row {
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
}

.popup-icon-circle {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  background: #fff3cd;
  border: 2px solid #ffc107;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #856404;
}

/* Title */
.popup-title {
  font-size: 1rem;
  font-weight: 700;
  color: #842029;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}

/* Message box — styled inner card */
.popup-message-box {
  background: #fff2f2;
  border: 1px solid #f5c6cb;
  border-left: 4px solid #dc3545;
  border-radius: 8px;
  padding: 10px 14px;
  margin-bottom: 18px;
  text-align: left;
}

.popup-message-text {
  font-size: 0.875rem;
  color: #5c1a1e;
  margin: 0;
  line-height: 1.55;
}

/* Close button */
.popup-close-btn {
  background: #dc3545;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 9px 0;
  transition: background 0.18s;
  letter-spacing: 0.3px;
}

.popup-close-btn:hover {
  background: #b02a37;
  color: #fff;
}

/* ── Mobile Restriction ──────── */
.mobile-restriction-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #0F4D96, #FD5E53);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  color: white;
}

.mobile-restriction-content {
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  padding: 40px;
  border-radius: 15px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-width: 500px;
  width: 100%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.mobile-logo {
  width: 80px;
  height: auto;
  margin-bottom: 20px;
  filter: brightness(0) invert(1);
}

.mobile-restriction-content h2 {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 15px;
}

.mobile-restriction-content p {
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 15px;
  color: #f8f9fa;
}

.mobile-info {
  background: rgba(255, 255, 255, 0.1);
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.mobile-info p {
  margin-bottom: 10px;
  font-size: 1rem;
}

/* ── Responsive ──────────────── */
@media (max-width: 767px) {
  .left-panel {
    clip-path: none;
    margin-top: 0;
    padding: 30px 20px;
    min-height: 220px;
  }

  .welcome-heading {
    font-size: 1.3rem;
  }

  .left-panel-sub {
    font-size: 0.85rem;
  }

  .right-panel {
    padding: 30px 16px 60px;
    align-items: flex-start !important;
  }

  .login-card {
    width: 100% !important;
    max-width: 460px;
  }

  .logo-wrapper {
    width: 200px;
    height: 52px;
  }
}

/* ── Animations ──────────────── */
@keyframes fadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes slideRight {
  from { transform: translateX(50px); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
}

@keyframes fadeUp {
  from { transform: translateY(20px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}`, "",{"version":3,"sources":["webpack://./src/components/WebManager/Auth/Login.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,8DAA8D;EAC9D,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,yDAA0E;EAC1E,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;4DAE4D;AAC5D;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,WAAW;EACX,qDAAqD;EACrD,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;;4DAE4D;;AAE5D,gDAAgD;AAChD;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,oCAAoC,KAAK;AAC9D;;AAEA,oCAAoC;AACpC;EACE,OAAO,wBAAwB,KAAK;EACpC,OAAO,2BAA2B,EAAE;EACpC,OAAO,0BAA0B,GAAG;EACpC,OAAO,2BAA2B,EAAE;EACpC,OAAO,0BAA0B,GAAG;EACpC,OAAO,2BAA2B,EAAE;EACpC,OAAO,0BAA0B,GAAG;EACpC,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,KAAK;AACtC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,qDAAqD;EACrD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;AACF;;AAEA,mCAAmC;AACnC;EACE,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD;;AAEA;EACE,OAAO,2BAA2B,EAAE,UAAU,EAAE;EAChD,OAAO,wBAAwB,KAAK,UAAU,EAAE;AAClD","sourcesContent":["/* ── Left Panel ─────────────── */\n.left-panel {\n  background: linear-gradient(135deg, #001F54, #007BFF, #32CD32);\n  clip-path: ellipse(85% 100% at 10% 50%);\n  padding: 20px;\n  text-align: center;\n  margin-top: -40px;\n}\n\n.left-panel-sub {\n  max-width: 420px;\n  margin: 0 auto;\n  font-size: 0.95rem;\n  line-height: 1.6;\n}\n\n/* ── Right Panel ─────────────── */\n.right-panel {\n  background-image: url(\"../../../Assets/DeWatermark.ai_1754806856125.jpeg\");\n  background-size: cover;\n  background-position: center;\n  position: relative;\n}\n\n.right-panel::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: rgba(255, 255, 255, 0.95);\n  z-index: 1;\n}\n\n.right-panel > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* ── Login Card ──────────────── */\n.login-card {\n  width: 460px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n/* ── Logo ────────────────────── */\n.logo-wrapper {\n  width: 280px;\n  height: 68px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n/* ── Change username link ────── */\n.change-link {\n  font-size: 0.78rem;\n  color: #0d6efd;\n  cursor: pointer;\n  text-decoration: underline;\n  user-select: none;\n}\n\n.change-link:hover {\n  color: #0056b3;\n}\n\n/* ── Input focus ─────────────── */\ninput:focus {\n  outline: none !important;\n  box-shadow: none !important;\n  border-color: inherit !important;\n}\n\n/* ══════════════════════════════════════════════════════════\n   RECENT LOGINS SECTION\n══════════════════════════════════════════════════════════ */\n.recent-logins-section {\n  border-top: 1px solid #dee2e6;\n  margin-top: 16px;\n  padding-top: 12px;\n}\n\n.recent-logins-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.recent-logins-title-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n}\n\n.recent-logins-icon {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  border: 1.5px solid #001F54;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  background: #fff;\n}\n\n.recent-logins-count-label {\n  font-size: 12px;\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.recent-logins-clear-btn {\n  font-size: 11px;\n  color: #dc3545;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  font-weight: 500;\n  flex-shrink: 0;\n}\n\n.recent-logins-clear-btn:hover {\n  text-decoration: underline;\n}\n\n.recent-logins-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.recent-login-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  background: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.recent-login-row:hover {\n  background: #f0f4ff;\n  border-color: #b0c4f0;\n}\n\n.recent-login-left {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.recent-login-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.recent-login-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.recent-login-username {\n  font-size: 13px;\n  font-weight: 500;\n  color: #212529;\n}\n\n.recent-login-badge {\n  font-size: 10px;\n  padding: 2px 8px;\n  border-radius: 20px;\n  font-weight: 500;\n  align-self: flex-start;\n  margin-top: 2px;\n}\n\n.recent-login-remove {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #f8d7da;\n  color: #842029;\n  border: none;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  line-height: 1;\n  padding: 0;\n  transition: background 0.15s;\n}\n\n.recent-login-remove:hover {\n  background: #f5c2c7;\n}\n\n/* ── Footer ──────────────────── */\n.footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  background: linear-gradient(135deg, #007BFF, #32CD32);\n  padding: 0.6rem 0;\n  display: flex;\n  align-items: center;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n}\n\n.footer .fw-bold {\n  font-size: 1rem;\n  letter-spacing: 0.5px;\n}\n\n/* ══════════════════════════════════════════════════════════\n   IMPROVED ERROR POPUP\n══════════════════════════════════════════════════════════ */\n\n/* Overlay — clicking outside closes the popup */\n.popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1050;\n  animation: overlayFadeIn 0.2s ease;\n}\n\n@keyframes overlayFadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Popup box */\n.popup-box {\n  background: #fff;\n  padding: 28px 24px 22px;\n  border-radius: 14px;\n  max-width: 360px;\n  width: 92%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);\n  animation: popupSlideUp 0.22s ease;\n  text-align: center;\n}\n\n@keyframes popupSlideUp {\n  from { opacity: 0; transform: translateY(18px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0)    scale(1);    }\n}\n\n/* Shake animation for wrong input */\n@keyframes popupShake {\n  0%   { transform: translateX(0);    }\n  12%  { transform: translateX(-8px); }\n  25%  { transform: translateX(7px);  }\n  37%  { transform: translateX(-6px); }\n  50%  { transform: translateX(5px);  }\n  62%  { transform: translateX(-4px); }\n  75%  { transform: translateX(3px);  }\n  87%  { transform: translateX(-2px); }\n  100% { transform: translateX(0);    }\n}\n\n.popup-shake {\n  animation: popupShake 0.6s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n/* Warning icon circle */\n.popup-icon-row {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 14px;\n}\n\n.popup-icon-circle {\n  width: 54px;\n  height: 54px;\n  border-radius: 50%;\n  background: #fff3cd;\n  border: 2px solid #ffc107;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  color: #856404;\n}\n\n/* Title */\n.popup-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #842029;\n  margin-bottom: 12px;\n  letter-spacing: 0.3px;\n}\n\n/* Message box — styled inner card */\n.popup-message-box {\n  background: #fff2f2;\n  border: 1px solid #f5c6cb;\n  border-left: 4px solid #dc3545;\n  border-radius: 8px;\n  padding: 10px 14px;\n  margin-bottom: 18px;\n  text-align: left;\n}\n\n.popup-message-text {\n  font-size: 0.875rem;\n  color: #5c1a1e;\n  margin: 0;\n  line-height: 1.55;\n}\n\n/* Close button */\n.popup-close-btn {\n  background: #dc3545;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 9px 0;\n  transition: background 0.18s;\n  letter-spacing: 0.3px;\n}\n\n.popup-close-btn:hover {\n  background: #b02a37;\n  color: #fff;\n}\n\n/* ── Mobile Restriction ──────── */\n.mobile-restriction-container {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #0F4D96, #FD5E53);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  color: white;\n}\n\n.mobile-restriction-content {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.1);\n  padding: 40px;\n  border-radius: 15px;\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  max-width: 500px;\n  width: 100%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n}\n\n.mobile-logo {\n  width: 80px;\n  height: auto;\n  margin-bottom: 20px;\n  filter: brightness(0) invert(1);\n}\n\n.mobile-restriction-content h2 {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 15px;\n}\n\n.mobile-restriction-content p {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 15px;\n  color: #f8f9fa;\n}\n\n.mobile-info {\n  background: rgba(255, 255, 255, 0.1);\n  padding: 20px;\n  border-radius: 10px;\n  margin-top: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.mobile-info p {\n  margin-bottom: 10px;\n  font-size: 1rem;\n}\n\n/* ── Responsive ──────────────── */\n@media (max-width: 767px) {\n  .left-panel {\n    clip-path: none;\n    margin-top: 0;\n    padding: 30px 20px;\n    min-height: 220px;\n  }\n\n  .welcome-heading {\n    font-size: 1.3rem;\n  }\n\n  .left-panel-sub {\n    font-size: 0.85rem;\n  }\n\n  .right-panel {\n    padding: 30px 16px 60px;\n    align-items: flex-start !important;\n  }\n\n  .login-card {\n    width: 100% !important;\n    max-width: 460px;\n  }\n\n  .logo-wrapper {\n    width: 200px;\n    height: 52px;\n  }\n}\n\n/* ── Animations ──────────────── */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n@keyframes slideRight {\n  from { transform: translateX(50px); opacity: 0; }\n  to   { transform: translateX(0);    opacity: 1; }\n}\n\n@keyframes fadeUp {\n  from { transform: translateY(20px); opacity: 0; }\n  to   { transform: translateY(0);    opacity: 1; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
